import { FORMULAR, GET_TEXT_FROM, POPIS_OSTATNI } from '@/main/store/getterTypes';
import { PageStoreBase } from '@/main/store/@types/page';

export const pageGetters = {
	getField: (state: any) => (path: string) => path.split(/[.[\]]+/).reduce((prev: any, key: any) => prev[<any>key], state),
	getCrumbDescription(state: PageStoreBase, getters: any, rootState: any, rootGetters: any) {
		const title = rootGetters[GET_TEXT_FROM](FORMULAR, state.crumb.label);
		const detail = state.crumb.detail ? ` (${state.crumb.detail})` : '';

		return `${title}${detail}`;
	},
	loading: (state: PageStoreBase) => state.loadingCount > 0,
};

export const listEditGetters = {
	getCrumbDescription(state: any, getters: any, rootState: any, rootGetters: any) {
		const title = rootGetters[GET_TEXT_FROM](FORMULAR, state.crumb.label);

		const mode = state.props.mode ? rootGetters[GET_TEXT_FROM](POPIS_OSTATNI, `mode${state.props.mode}`) : '';
		const detail = state.crumb.detail ? ` (${state.crumb.detail})` : '';


		return (mode.length || detail.length) ? `${title} - ${mode}${detail}` : title;
	},
};
